import axios from "axios";
import GenericSwiper from "../shared/SwiperCustomComponent/GenericSwiper";
import ProductContext from "../shared/contexts/ProductContext";
import { useEffect, useRef, useState } from "react";
import Game from "../Game";
import "../../styles/globals.scss";
import SearchableDropdown from "../shared/SearchableDropdown";
import { clsx } from "clsx";
import OneProduct from "../OneProduct";
import {
  categoriesTypes,
  // getFilesByParam,
  replaceItemsLink,
} from "../../utils/helper";
import Title from "../Title";
import Coupons from "../Coupons";
import Banner from "../Banner";
import HotProduct from "../HotProduct";
import MainSwiper from "../MainSwiper";
import ProductSwiper from "../ProductSwiper";
import Loader from "../shared/site/Loader";
// import ProductPartial from "../ProductPartial";
// import NewsFeedSwiper from "../NewsFeedSwiper";
// import NewsFeed from "../NewsFeed";
const Home = () => {
  // const param = "Goldia";
  // const files = getFilesByParam(param);
  // console.log(process.env.REACT_APP_API_ENDPOINT);
  const [pageNumber, setPageNumber] = useState(1);
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [videos, setVideos] = useState([]);
  const [oneProduct, setOneProduct] = useState(null);
  const [generateLink, setGenerateLink] = useState(null);
  const [searchableText, setSearchableText] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState(true);
  const [loadingBigItem, setLoadingBigItem] = useState(false);
  const pageSize = 20;

  let oldKeyward = "";
  let defaultKeyword = "";

  const [keyword, setKeyword] = useState(oldKeyward);
  let swiperRef = useRef(null);

  // https://devtrium.com/posts/async-functions-useeffect

  // declare the async data fetching function
  const fetchProducts = async (pageNumber, keywords) => {
    // console.log("fetchProducts");
    setLoading(true);
    const res = await axios(`${process.env.REACT_APP_API_ENDPOINT}/products`, {
      params: {
        pageNumber: pageNumber,
        pageSize: pageSize,
        keywords: keywords,
      },
    });
    let results = res?.data?.resp_result?.result?.products?.product;
    if (results === undefined || results?.length <= 0) {
      setLoading(false);
      return;
    }

    if (results?.[0]?.product_id !== undefined) {
      // console.log(results);

      if (results?.[0] !== undefined || results?.[0] !== null)
        fetchProduct(results[0]?.product_id);
    }

    setItems((prev) => [...prev, ...results]);
    setLoading(false);
  };

  // declare the async data fetching function
  const fetchProduct = async (product_id) => {
    // console.log("fetchProduct");
    setLoadingBigItem(true);
    const res = await axios(
      `${process.env.REACT_APP_API_ENDPOINT}/taobao_product`,
      {
        params: {
          product_id: product_id,
        },
      }
    );
    let results = res?.data?.resp_result?.result.products;

    let generateLink = await replaceItemsLink(
      results?.product[0]?.promotion_link
    );
    // console.log(newResults);
    setGenerateLink(generateLink);
    setOneProduct(results);
    setLoadingBigItem(false);
    // console.log(res);
  };

  const fetchDataByKeyward = async (key) => {
    // console.log("fetchDataByKeyward");
    setLoading(true);
    const res = await axios(`${process.env.REACT_APP_API_ENDPOINT}/products`, {
      params: {
        pageNumber: pageNumber,
        pageSize: pageSize,
        keywords: key,
      },
    });

    let results = res?.data?.resp_result?.result?.products?.product;
    if (results === undefined || results?.length <= 0) {
      setLoading(false);
      return;
    }
    setItems(results);
    setLoading(false);
  };

  // declare the async data fetching function
  const fetchCategory = async () => {
    // console.log("fetchCategory");
    const res = await axios(
      `${process.env.REACT_APP_API_ENDPOINT}/taobao_getCategory`,
      {}
    );
    // console.log("categories");
    // console.log(res?.data?.resp_result?.result?.categories?.category);
    let categoryResults =
      res?.data?.resp_result?.result?.categories?.category?.filter(
        (item) => item.category_id !== 200001508 //removing sex products
      );

    var categoryName =
      categoriesTypes[
        Math.floor(Math.random() * (categoriesTypes?.length - 1))
      ];
    oldKeyward = categoryName;
    defaultKeyword = categoryName;
    setKeyword(categoryName);
    setCategories(categoryResults);
    // console.log(categoryName);
  };

  useEffect(() => {
    fetchProducts(pageNumber, keyword)?.catch(console.error); // make sure to catch any error
  }, [pageNumber, keyword]);

  useEffect(() => {
    fetchCategory()?.catch(console.error);
  }, []);

  const fetchCoupons = async () => {
    try {
      setLoadingCoupon(true);
      const results = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/coupons`
      );
      setCoupons(results?.data);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setLoadingCoupon(false); // ✅ Ensures loading is false after success or error
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []); // ✅ Runs only once on mount

  const fetchVideos = async () => {
    const results = await axios(`${process.env.REACT_APP_API_ENDPOINT}/videos`);
    setVideos(results?.data);
    // let mainVideos = results?.data?.filter(
    //   (item) => item?.isMain?.toLowerCase() !== "true"
    // );
    // debugger;
  };

  useEffect(() => {
    fetchVideos()?.catch(console.error);
  }, []);

  let providerObject = {
    setPageNumber,
    pageNumber,
    pageSize,
    items,
    setItems,
    keyword,
    setKeyword,
    loading,
    activeIndex,
    setActiveIndex,
    setSearchableText,
    oldKeyward,
    fetchDataByKeyward,
    defaultKeyword,
    swiperRef,
    oneProduct,
    fetchProduct,
    loadingBigItem,
    generateLink,
    videos,
  };
  const swiperItems = [
    // {
    //   title: "CHATRIUM HOTELS & RESIDENCES",
    //   description: `Elegant spaces in remarkable places. Discover action-packed urban escapes and secluded sanctuaries where wellness, adventure, world-class service and gastronomy are a given. Check more...`,
    //   Name: "",
    //   link: "Category/Hotels/Charitum",
    //   newWindow: false,
    //   background: "#fff",
    //   isContain: false,
    //   urlToImage:
    //     "https://image-tc.galaxy.tf/wijpeg-7mg5mmnvzfuvoj0ivydcbeaih/pipeder-20221018-dji-0097-red-1-1-compress.jpg?width=3806&height=1766",
    // },
    {
      title: "Solar Generator 3000 Pro",
      description: `The Ultimate Power Master. Check more...`,
      Name: "",
      link: "Category/Solar/Jackery",
      newWindow: false,
      background: "#fff",
      isContain: false,
      urlToImage:
        "https://i.shgcdn.com/76de6fe3-fe00-4e8b-a9cc-88c3b28ff29d/-/format/auto/-/preview/3000x3000/-/quality/lighter/",
    },
    {
      title: "Overhalf sale",
      description: `Fashion from Head To Toe at affordable prices. Check more...`,
      Name: "",
      link: "Category/MixedProducts/Overhalfsale",
      newWindow: false,
      background: "#fff",
      isContain: true,
      urlToImage:
        "https://cdn.shopify.com/s/files/1/0011/8361/2983/collections/New_Arrival_2400x.jpg?v=1631618586",
    },
    // {
    //   title: "Mons Peak IX",
    //   description: `Mons Peak IX New Revolutionary 2-in-1 Backpacking and Camping Tents`,
    //   Name: "",
    //   link: "Category/Camping/monspeakix",
    //   newWindow: false,
    //   background: "#fff",
    //   isContain: true,
    //   urlToImage:
    //     "https://cdn.shopify.com/s/files/1/1373/7403/files/mons-peak-ix-iceland-9_d16f46b7-7a30-465f-945b-09bd648223a1_2048x.jpg?v=1613153196",
    // },
    {
      title: "Auxbeam",
      description: `Check more...`,
      Name: "",
      link: "Category/Vehicules/Auxbeam",
      newWindow: false,
      background: "#fff",
      isContain: true,
      isContain: true,
      urlToImage:
        "https://cdn.shopify.com/s/files/1/0559/5725/8445/products/QP008526_3.jpg?v=1641351015",
    },
    // {
    //   title: "Rosewe",
    //   description: `Check more...`,
    //   Name: "",
    //   link: "Category/Clothes/Rosewe",
    //   newWindow: false,
    //   background: "#fff",
    //   isContain: true,
    //   isContain: true,
    //   urlToImage:
    //     "https://www.rosewe.com/images/202209/source_img/312804_P_16638092154800.jpg",
    // },
    // {
    //   title: "DressLily",
    //   description: `Check more...`,
    //   Name: "",
    //   link: "Category/Clothes/DressLily",
    //   newWindow: false,
    //   background: "#fff",
    //   isContain: true,
    //   isContain: true,
    //   urlToImage:
    //     "https://gloimg.drlcdn.com/L/pdm-product-pic/Clothing/2023/02/28/source-img/20230228105138_63fd6c3ab1ece.jpg",
    // },
    // {
    //   title: "Baby Monitor",
    //   description: `Bundle (2K PTZ Video+Baby 3). Check more...`,
    //   Name: "",
    //   link: "Category/Electronics/Sense-U",
    //   newWindow: false,
    //   background: "#fff",
    //   isContain: true,
    //   urlToImage: "https://static.shareasale.com/image/102134/Ads_Baby2_2.png",
    // },
    // {
    //   title: "EveBands",
    //   description: `Check more...`,
    //   Name: "",
    //   link: "Category/Accessories/EveBands",
    //   newWindow: false,
    //   background: "#fff",
    //   isContain: true,
    //   urlToImage:
    //     "https://cdn.shopify.com/s/files/1/0573/5091/4229/files/upgrade-watch-5.png",
    // },
    {
      title: "Maven",
      description: `Safety Shoes. Check more...`,
      Name: "",
      link: "Category/Shoes/Maven",
      newWindow: false,
      background: "#000",
      isContain: false,
      urlToImage:
        "https://cdn.shopify.com/s/files/1/0324/2934/2859/files/MAVEN_SAFETY_SHOES_BANNER.jpg?v=1639456543&width=3806&height=1766",
    },
  ];

  // Baby Monitor $399.99 Sale price $349.99
  // Coupon:80OFF
  // $80 OFF Sense-U Bundle 3+
  // Start Date 04/23/2023 End Date 06/30/2023
  // https://shrsl.com/41cb5
  // const techApi = `https://newsapi.org/v2/top-headlines?sources=techcrunch&apiKey=cb4bde34b5944c1d9f54c9ab455d41a1`;
  // const usApi =
  // "https://newsapi.org/v2/top-headlines?country=us&category=business&apiKey=cb4bde34b5944c1d9f54c9ab455d41a1";
  return (
    <ProductContext.Provider value={providerObject}>
      <main className="theme1">
        {/* <Banner isPopup={true} numberOfDays={5}>
          <a target="_blank" href="https://shrsl.com/40xq1" rel="noreferrer">
            <img
              src="https://static.shareasale.com/image/126440/4B03E31F-64BD-A397-4A0DFF6AF27FB4FD.jpg"
              border="0"
              alt="Chatrium Hotels &amp;amp; Residences"
            />
          </a>
        </Banner> */}
        <div className="main-header-title gradient-text">
          <h1>Get Free Coupons & Discount Codes for Top Stores</h1>
        </div>
        <MainSwiper swiperItems={swiperItems} />

        <Banner>
          <a target="_blank" href="https://shrsl.com/40cln" rel="noreferrer">
            <img
              src="https://static.shareasale.com/image/5903/5-1-14Wedding-992x260_00.jpg"
              border="0"
              alt="Gold Wedding Band Rings"
            />
          </a>
        </Banner>
        {/* <NewsFeed api={techApi} /> */}
        <ProductSwiper
          param="jackery"
          filename={`/Category/Solar/jackery-data.txt`}
        />
        {/* <ProductPartial
          dataprop={{
            files,
            param,
          }}
        /> */}

        {/* <Banner>
          <a target="_blank" href="https://shrsl.com/417be">
            <img
              src="https://static.shareasale.com/image/137513/728-x-90.gif"
              border="0"
              alt="the strongest snacks"
            />
          </a>
        </Banner> */}
        <div className={clsx("comp-wrap", loadingCoupon && "is-loading")}>
          <div className="main-header-title gradient-text">
            <h2>Free Coupons:</h2>
          </div>
          <Coupons items={coupons} />

          {loadingCoupon && <Loader />}
        </div>
        <Banner>
          <a target="_blank" href="https://shrsl.com/40yt8">
            <img
              src="https://static.shareasale.com/image/97366/deal/2000PRO-1080x1080.jpg"
              border="0"
              alt="Go Green with Jackery Solar Up to $900 Off Apr.14-22"
            />
          </a>
        </Banner>
        {/* <NewsFeed api={usApi} /> */}

        {/* <MainVideo
          videos={[
            {
              title: "Jackery",
              link: videoUrl,
            },
          ]}
        /> */}

        {/* <MainVideo
          video={
            videos &&
            videos?.filter((item) => item?.isMain?.toLowerCase() === "true")
          }
        /> */}

        {/* <CouponFileReader
          filename="jackery.txt"
          title={`Jackery Coupons:`}
          logo={"/local/jackeryLogo.svg"}
          bgColor={"rgb(251, 81, 42)"}
          theme={"dark"}
          name={"Jackery"}
        /> */}
        {/* <EarthQuake />
        <EarthQuakeFeed /> */}
        {/* <VideoSwiper
          items={videos?.filter(
            (item) => item?.isMain?.toLowerCase() !== "true"
          )}
        /> */}

        {/* <Banner>
          <a target="_blank" href="https://shrsl.com/40cll" rel="noreferrer">
            <img
              src="https://static.shareasale.com/image/56695/BEA1F35D6451890909E1F58A03E8AC7A.jpg"
              border="0"
              alt="dresslily spring sale!Buy$59 Get15%off,Buy$99 Get25%off,Buy$129 Get30%off!"
            />
          </a>
        </Banner> */}

        {/* <Banner>
          <a target="_blank" rel="noreferrer" href="https://shrsl.com/40yt6">
            <img
              src="https://static.shareasale.com/image/126440/CHR-BANER-392x7241.jpg"
              border="0"
              alt={`banner`}
            />
          </a>
        </Banner> */}
        <Title
          content="Affilate Ali Express products:"
          color="primary-color"
          position={"center"}
        />
        <div className={clsx("comp-wrap", loading && "is-loading")}>
          <div className="comp-cont">
            <br />
            <SearchableDropdown
              items={categories}
              searchableText={searchableText}
            />
            <br />
          </div>
        </div>
        <GenericSwiper
          items={items}
          isImageOnly={true}
          centeredSlides={false}
          scrollbar={true}
          mousewheel={true}
        />
        <Game />
        <OneProduct isImageOnly={false} isBigItem={true} />

        <HotProduct />

        <Banner>
          <a target="_blank" href="https://shrsl.com/40yt7">
            <img
              src="https://static.shareasale.com/image/97366/728x908_00.jpg"
              border="0"
              alt="Go Green with Jackery Solar Up to $900 Off Apr.14-22"
            />
          </a>
        </Banner>
        {/* <Banner>
          <a target="_blank" href="https://shrsl.com/40clo" rel="noreferrer">
            <img
              alt={`banner eve bands`}
              src="https://static.shareasale.com/image/125505/a3.gif"
              border="0"
            />
          </a>
        </Banner> */}
      </main>
    </ProductContext.Provider>
  );
};
export default Home;
